<template>
    <div>
        <b-tabs pills active-nav-item-class="nav-pill-warning" nav-class="bg-light p-25 custom-nav">
            <b-tab title="Genel" active>
                <employee-netsis-common v-model="value" :id="id" :branch="branch" :aktif-netsis-sube="aktifNetsisSube" :get-personal="getPersonal" :sgk-salary="sgkSalary"></employee-netsis-common>
            </b-tab>
            <b-tab title="Terkin">
                <employee-netsis-terkin v-model="value"></employee-netsis-terkin>
            </b-tab>
        </b-tabs>
        <div class="d-flex flex-column align-items-end">
            <b-form-checkbox v-model="sifirla" class="mb-75">Puantajı Sıfırla</b-form-checkbox>
            <v-executer :loading="loading" class="text-nowrap" text="NETSIS Bilgilerini Kaydet" :action="save"></v-executer>
        </div>
    </div>
</template>

<script>
import { BTab,BTabs, BFormCheckbox } from 'bootstrap-vue';
import EmployeeNetsisCommon from './components/EmployeeNetsisCommon.vue'
import EmployeeNetsisTerkin from './components/EmployeeNetsisTerkin.vue'
import Additional from '@/utilities/additional'
import EmployeeOperationsApi from '@/api/employee-operations' 

export default {
    components:{
        BTabs,
        BTab,
        EmployeeNetsisCommon,
        EmployeeNetsisTerkin,
        BFormCheckbox
    },
    props:{
        aktifNetsisSube:String,
        sgkSalary:Object,
        value:Object,
        id:[String,Number],
        getPersonal:Function,
        branch:Object,
        isMinimumWage:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            loading:false,
            sifirla:false,
            date:null
        }
    },
    methods:{
        save(){
            this.$confirm("Netsis bilgilerini güncellemek istediğinize emin misiniz?",
            !this.sifirla ? "İşlemler Netsis'in mevcut dönem bilgisine göre yapılacaktır."
            : "Personelin netsisteki tüm puantaj bilgisi sıfırlanacak ve işlemler Netsis'in mevcut dönem bilgisine göre yapılacaktır."
            ).then(async (res) => {
                if(res){
                    let data = {
                        Step:8,
                        EmployeeId:this.id,
                        NetsisModel:{
                            PuantajSifirla:this.sifirla,
                            ...this.value,
                            ASGARI_UCRETLI: this.isMinimumWage ? 'E' : 'H'
                        },
                    }
                    let formData = await Additional.ToFormData(data)
                    this.loading = true
                    EmployeeOperationsApi.Employee.CreateOrUpdate(formData).then(res=>{
                        this.$result(res)
                        this.loading = false
                        if(res.data.Success){
                            this.getPersonal()
                        }
                    }).catch(err=>{
                        this.loading = false
                        this.$result(null,err)
                    })
                }
            })
        },
    }
}
</script>

<style>

</style>